import React, { memo } from 'react';

import { StubProps } from '../Stub';
import { TextStubWithSkin } from '../Text';

import { ParagraphSize } from './types';
import { paragraphSizeToSkin } from './utils';

export interface ParagraphStubProps extends Omit<StubProps, 'height' | 'borderRadius'> {
    /**
     * Размер параграфа
     * @default 'm'
     */
    size?: ParagraphSize;
}

export const ParagraphStub = memo<ParagraphStubProps>(function ParagraphStub({ size = 'm', className, ...props }) {
    const skinSize = paragraphSizeToSkin[size];

    return <TextStubWithSkin skinSize={skinSize} height={'current-main'} className={className} {...props} />;
});
